import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-container" }

import { ref, computed, watch, watchEffect } from 'vue';
import sidebarItem from './sidebarItem.vue';
import { usePermissionStoreHook } from '@/store/modules/permission';
import { useTagsStoreHook } from '@/store/modules/tags';
import { findRouteByPath } from '@/router/utils';
import { useRoute, useRouter } from 'vue-router';
import { getDirectory } from './util';
import { useLayoutStoreHook } from '@/store/modules/layout';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();

const router = useRouter();
const route = useRoute();

const activeIndex = computed(() => {
  return route.path;
});

const routeList = usePermissionStoreHook().wholeMenus;
console.log(26, routeList.length);

const onSelect = (item: any) => {
  const path = item.key;
  const route = findRouteByPath(routeList, path);
  useTagsStoreHook().changeTag(route);
  router.push(path);
};

const selectedKeys = ref([route.path]);
const openKeys = ref(['/functional']);
watchEffect(() => {
  if (layoutStore.layout === 'vertical') {
    openKeys.value = getDirectory(routeList, activeIndex.value);
  } else {
    openKeys.value = [];
  }
});
const mode = computed(() => {
  if (layoutStore.layout === 'vertical') {
    return 'inline';
  }
  return layoutStore.layout;
});
watch(
  () => openKeys.value,
  (nvl) => {
    console.log(nvl);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      ellipsis: false,
      "selected-keys": selectedKeys.value,
      "onUpdate:selected-keys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
      "open-keys": openKeys.value,
      "onUpdate:open-keys": _cache[1] || (_cache[1] = ($event: any) => ((openKeys).value = $event)),
      subMenuCloseDelay: 0.2,
      mode: _unref(mode),
      "inline-collapsed": !_unref(layoutStore).opened,
      onSelect: onSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routeList), (route) => {
          return (_openBlock(), _createBlock(sidebarItem, {
            key: route.path,
            item: route,
            "base-path": route.path
          }, null, 8, ["item", "base-path"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["selected-keys", "open-keys", "subMenuCloseDelay", "mode", "inline-collapsed"])
  ]))
}
}

})